import SettingsUI from './components/SettingsUI';

const Settings = () => {
  return (
    <SettingsUI />
  );
}

export default Settings;
